import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard.UserInfoStep', {
    title: "Let's get you set up",
});
